export default "__VITE_ASSET__0ccea49d__"